import React from "react";

class DoughnutProvider extends React.Component {
  static defaultProps = {
    interval: 100
  };

  state = {
    valuesIndex: 0
  };

  timeout = null;

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        valuesIndex: (this.state.valuesIndex + 1) % this.props.values.length
      });
    }, this.props.interval + 50 * this.props.indexGraph || 0);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    return this.props.children(this.props.values[this.state.valuesIndex]);
  }
}

export default DoughnutProvider;



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Global/DoughnutProvider.js